import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=0f0f201c&scoped=true&"
import script from "./EditorHeader.vue?vue&type=script&lang=js&"
export * from "./EditorHeader.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=0f0f201c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f201c",
  null
  
)

export default component.exports